import { AES } from "crypto-js";

export const generateTokenEmrSetting = (settings = []) => {
  const EMR_OPEN_API_KEY =
    process.env.REACT_APP_EMR_OPEN_API_KEY || "Ann154Annisa2021*#";

  const timestamp = new Date().getTime();
  const data = {
    ms_hos_keys: settings,
    timestamp: timestamp,
  };
  let ciphertext = AES.encrypt(
    JSON.stringify(data),
    EMR_OPEN_API_KEY
  ).toString();
  for (let i = 0; i < 7; i++) {
    ciphertext = AES.encrypt(ciphertext, EMR_OPEN_API_KEY).toString();
  }

  return ciphertext;
};
